import { IItem } from "../stores/scannerStore";

class ScannerHelper {
    
    findMaxValidFrom(items: IItem[]): number {
        return items.reduce((oa, u) => Math.max(oa, new Date(u.validFrom).getTime()), 0);
    }

    selectMany<TIn, TOut>(input: TIn[], selectListFn: (t: TIn) => TOut[]): TOut[] {
        return input.reduce((out, inx) => {
          out.push(...selectListFn(inx));
          return out;
        }, new Array<TOut>());
      }
}

export default new ScannerHelper();